import { getSession, getSettingsCollection } from "@DSG/Overrides/Store/Context/ContextSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import Link from "@insite/mobius/Link/Link";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

type Props =  ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory;

    
const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        isAuthenticated: state.context.session.isAuthenticated,
        session,
        canSeePrices: getSettingsCollection(state).productSettings.canSeePrices,
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentLocation: getLocation(state),
    };
};
const mapDispatchToProps = {
};

export interface CoveoViewSignInPricingButtonStyles {
    wrapperPricingSign?: InjectableCss;
}

export const coveoViewSignInPricingButtonStyles: CoveoViewSignInPricingButtonStyles = {
    wrapperPricingSign: {
        css: css`
            width: 100%;
            [data-test-selector="coveoProductPrice_PricingMessageSignIn"] {
                width: 100%;
                padding-left: 4px;
                padding-right: 4px;
            }
        `
    }
}

const styles = coveoViewSignInPricingButtonStyles;

const CoveoViewSignInPricingButton = ({
    history,
    ...props
}: Props) => {

    const redirectToSignIn = () => {
        const { pathname, search, hash } = props.currentLocation; 
        const returnUrl = pathname + search + hash;

        const currentUrl = new URL(window.location.href);   
        const hashParts = currentUrl.hash.split('#');
        const searchParams = new URLSearchParams(currentUrl.search);
        
        // Get facet selections from URL hash
        const facetParams = hashParts[1] ? `#${hashParts[1]}` : '';

        if (returnUrl === "/") {
            history.push(`${props.signInUrl}`);            
        } else {
            // Include both search params and hash in the return URL to preserve facet selections
            const fullReturnUrl = pathname + 
                (searchParams.toString() ? `?${searchParams.toString()}` : '') + 
                (facetParams ? facetParams : '');
            
            history.push(`${props.signInUrl}?returnUrl=${encodeURIComponent(fullReturnUrl)}`);
        }
    }

    return (
        <>
            {(!props.isAuthenticated && !props.canSeePrices) && (
                <StyledWrapper {...styles.wrapperPricingSign} className="signInWrapperPrice">
                    {props.signInUrl && 
                        <Link onClick={redirectToSignIn} className="link-btn primary-link-btn" data-test-selector="coveoProductPrice_PricingMessageSignIn">
                            {siteMessage("Pricing_SignInForPrice")}
                        </Link>
                    }
                </StyledWrapper>
            )}
        </>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(CoveoViewSignInPricingButton));